import {
  LOGIN_SU_USER,
  LOGIN_SU_SUCCESS,
  LOGOUT_SU_USER,
  LOGOUT_SU_USER_SUCCESS,
  API_SU_ERROR,
  } from "./constant"
  
  const initialState = {
    error: "",
    loading: false,
  }
  
  const SuperUserLogin = (state = initialState, action) => {
    switch (action.type) {
      case LOGIN_SU_USER:
        state = {
          ...state,
          loading: true,
        }
        break
      case LOGIN_SU_SUCCESS:
        state = {
          ...state,
          loading: false,
          isUserLogout: false,
        }
        break
      case LOGOUT_SU_USER:
        state = { ...state }
        break
      case LOGOUT_SU_USER_SUCCESS:
        state = { ...state , isUserLogout: true}
        break
      case API_SU_ERROR:
        state = { ...state, error: action.payload, loading: false,isUserLogout: false, }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default SuperUserLogin
  